import { render, staticRenderFns } from "./SpaceForm.vue?vue&type=template&id=19734022&scoped=true&"
import script from "./SpaceForm.vue?vue&type=script&lang=js&"
export * from "./SpaceForm.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/forms.css?vue&type=style&index=0&id=19734022&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19734022",
  null
  
)

export default component.exports